import {Injectable} from "@angular/core";
import {HttpClient} from "@angular/common/http";
import {environment} from "../../environments/environment";

@Injectable({
    providedIn: 'root',
})
export class ProviderService {
    private readonly CERT_API: string;

    constructor(private http: HttpClient) {
        this.CERT_API = `${environment.apiUrl}/providers/`;
    }

    async getAll(module: string): Promise<any> {
        return await this.http.get(this.CERT_API + `all/${module}`).toPromise();
    }

    async getAllProvider(): Promise<any> {
        return await this.http.get(this.CERT_API + `all-providers`).toPromise();
    }
}